import { ORDER_STATE } from './orderState';

export const ORDER_STATE_LABELS: Record<ORDER_STATE, string> = {
  [ORDER_STATE.CREATED]: 'Creada',
  [ORDER_STATE.PENDING]: 'Pendiente',
  [ORDER_STATE.PAYMENT_PROBLEM]: 'Problema de pago',
  [ORDER_STATE.PAID]: 'Pagada',
  [ORDER_STATE.CANCELLED]: 'Cancelada',
  [ORDER_STATE.ABANDONED]: 'Abandonada',
  [ORDER_STATE.NO_INSTERESTED]: 'No interesado',
  [ORDER_STATE.SENT_TO_COURIER]: 'Enviada al courier',
  [ORDER_STATE.APPROVED_BY_COURIER]: 'Aprobada por el courier',
  [ORDER_STATE.CANCELED_BY_COURIER]: 'Cancelada por el courier',
};

export const ORDER_STATE_LABELS_ES: Record<string, string> = {
  Created: 'Creada',
  Pending: 'Pendiente',
  'Payment Problem': 'Problema de pago',
  Paid: 'Pagada',
  Cancelled: 'Cancelada',
  Abandoned: 'Abandonada',
  'Not Interested': 'Sin interés',
  SentToCourier: 'Enviada al courier',
  ApprovedByCourier: 'Aprobada por courier',
  CanceledByCourier: 'Cancelada por courier',
};

